import script from "./SignIn.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignIn.vue?vue&type=script&lang=ts&setup=true"

import "./SignIn.vue?vue&type=style&index=0&id=6c79da14&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c79da14"]])

export default __exports__